<script>
import ButtonWithLoadWebsite from "../../components/shared/ButtonWithLoadWebsite.vue";
import Modal from "../../components/shared/Modal/Modal.vue";
import { DataService } from "../../config/dataService";
import store from "../../vuex/store";
import BillingForm from "../Billing/BillingForm.vue";
import DataPage from "../DataPage/DataPage.vue";

const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

export default {
  components: {
    Modal,
    DataPage,
    ButtonWithLoadWebsite,
    BillingForm,
  },
  data() {
    return {
      isAddTextModalOpen: false,
      text: "",
      minLength: 50,
      maxLength: 1500,
      errorMessage: "",
      billingModalShown: false,
    };
  },
  computed: {
    isLoading() {
      return store.getters.isLoading;
    },

    chosenWidget() {
      return store.state.users.chosenWidget;
    },

    isTextLengthError() {
      if (this.text.length < this.minLength && this.text !== "") {
        this.errorMessage = `Min length ${this.minLength}`;
        return true;
      }

      if (this.text.length >= this.maxLength) {
        this.errorMessage = `Max length ${this.maxLength}`;
        return true;
      }

      this.errorMessage = "";
      return false;
    },

    isSubscriptionChecked() {
      const subscriptionStatus = this.chosenWidget?.owner?.subscription
        ? this.chosenWidget?.owner?.subscription?.status
        : this.chosenWidget?.owner?.subscription;

      if (subscriptionStatus || subscriptionStatus === "active") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {},
  methods: {
    async updateChosenWidget() {
      try {
        const result = await DataService.get(
          `${API_ENDPOINT}widget/get-by-id/${this.chosenWidget?.id}`
        );

        store.dispatch("setChosen", result?.data);
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.errorDescription ||
            "Update chosen widget error"
        );
      }
    },

    handleAddClick() {
      if (!this.isSubscriptionChecked) {
        return (this.billingModalShown = true);
      }

      this.isAddTextModalOpen = true;
    },

    async handleTextAdd() {
      const text = this.text;

      try {
        store.dispatch("startLoading");
        await DataService.post(
          `${API_ENDPOINT}widget/addSource/${this.chosenWidget?.id}`,
          { data: { sources: [text] }, sourceType: "text" },
          { widgetId: this.chosenWidget?.id }
        );

        await this.updateChosenWidget(this.chosenWidget?.id);

        this.isAddTextModalOpen = false;
        this.text = "";
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.errorDescription || "Text add error"
        );
      } finally {
        store.dispatch("endLoading");
      }
    },
  },
};
</script>

<template>
  <div>
    <DataPage @addClick="handleAddClick" dataType="text" title="Texts" />

    <Modal :isModalOpen="billingModalShown" @close="billingModalShown = false">
      <div slot="body" class="modal_body">
        <BillingForm type="modal" />
      </div>
    </Modal>

    <Modal
      :isModalOpen="isAddTextModalOpen"
      @close="isAddTextModalOpen = false"
    >
      <div slot="body" class="text_modal__box">
        <h5 class="add_link_title">Add new text</h5>

        <form @submit.prevent="handleTextAdd">
          <div class="textarea__box">
            <textarea
              v-model="text"
              class="text_textarea"
              v-bind:class="{ error: isTextLengthError }"
              :minlength="minLength"
              :maxlength="maxLength"
              placeholder="What is the pricing of the product?
The pricing of the product is 99$

How to contact you?
You can contact me via email pollyjelnova@gmail.com"
            >
            </textarea>
            <p v-if="isTextLengthError" class="error-message">
              {{ errorMessage }}
            </p>
          </div>
          <div class="button__box">
            <ButtonWithLoadWebsite
              type="submit"
              :title="'addText'"
              :isDisabled="text.length < minLength"
            />
          </div>
        </form>
      </div>
    </Modal>
  </div>
</template>

<style scoped>
.add_link_title {
  color: #4f4f4f;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 32px;

  @media screen and (max-width: 1024px) {
    margin-bottom: 8px;
  }
}

.text_modal__box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  & > form {
    width: 100%;
    height: 70%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media screen and (min-width: 1024px) {
      height: 500px;
      width: 600px;
    }

    @media screen and (max-width: 768px) {
      height: 60vh;
    }

    @media screen and (max-width: 420px) {
      height: 500px;
    }
  }

  .textarea__box {
    position: relative;
    flex-grow: 1;
    height: 90%;
  }

  .text_textarea {
    width: 100% !important;
    height: 100% !important;
    max-width: 873px;
    resize: none;
    position: relative;
    padding: 12px 20px;
    border-radius: 6px;
    border: 1px solid #d1d1d6;

    &:focus-visible {
      outline-color: #3056d3;
    }

    &:focus-visible.error {
      outline-color: red;
    }
  }

  .error-message {
    position: absolute;
    bottom: -32px;
    left: 0;
    color: red;
    margin: 0;
  }

  .button__box {
    display: flex !important;
    justify-content: flex-end;
    margin-top: 16px;
  }
}
</style>
